module.exports = __webpack_public_path__ + "static/camelib-family-11ed1c3125ea882eb09c89fb84c557c9.jpg";